// eslint-disable-next-line import/prefer-default-export
export const INBOX_PAGE_SIZE = 10;
